const LAYOUT_TYPES ={
    VERTICAL : "vertical",
    HORIZONTAL : "horizontal",
    TWOCOLUMN : "twocolumn",
  }
  
  const LAYOUT_MODE_TYPES ={
    LIGHTMODE : "light",
    DARKMODE : "dark",
  }
  
  const LAYOUT_SIDEBAR_TYPES ={
    LIGHT : "light",
    DARK : "dark",
    GRADIENT : "gradient",
    GRADIENT_2 : "gradient-2",
    GRADIENT_3 : "gradient-3",
    GRADIENT_4 : "gradient-4",
  }
  
  const LAYOUT_WIDTH_TYPES ={
    FLUID : "fluid",
    BOXED : "boxed",
  }
  
  const LAYOUT_POSITION_TYPES ={
    FIXED : "fixed",
    SCROLLABLE : "scrollable",
  }
  
  const LAYOUT_TOPBAR_THEME_TYPES ={
    WARNING : "warning",
    DANGER : "danger",
    SUCCESS : "success"
  }
  
  const LEFT_SIDEBAR_SIZE_TYPES ={
    DEFAULT : "lg",
    COMPACT : "md",
    SMALLICON : "sm",
    SMALLHOVER : "sm-hover"
  }
  
  const LEFT_SIDEBAR_VIEW_TYPES ={
    DEFAULT : "default",
    DETACHED : "detached"
  }
  
  const LEFT_SIDEBAR_IMAGE_TYPES ={
    NONE : "none",
    IMG1 : "img-1",
    IMG2 : "img-2",
    IMG3 : "img-3",
    IMG4 : "img-4",
  };
  
  const PERLOADER_TYPES ={
    ENABLE : "enable",
    DISABLE : "disable"
  };
  
  export { 
    LAYOUT_TYPES,
    LAYOUT_MODE_TYPES,
    LAYOUT_SIDEBAR_TYPES,
    LAYOUT_WIDTH_TYPES,
    LAYOUT_POSITION_TYPES,
    LAYOUT_TOPBAR_THEME_TYPES,
    LEFT_SIDEBAR_SIZE_TYPES,
    LEFT_SIDEBAR_VIEW_TYPES,
    LEFT_SIDEBAR_IMAGE_TYPES,
    PERLOADER_TYPES
  }